module.exports = __webpack_public_path__ + "img/137.0524ceff.jpg";